// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__vftrl","footer":"Form_footer__3notv"};